import styled from 'styled-components';

export const StyledContent = styled.div`
  position: relative;
`;
